import React, { useState } from "react";
import { Modal } from "../../../../shared/Modal/Modal";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
import styles from "./styles.module.scss";
import { Footer } from "./shared/Footer";
import { Options } from "./shared/Options";
import { SecurityQuestion } from "./shared/SecurityQuestion";
import { Otp } from "./shared/Otp";
import { passOr } from "../../../../utilities/general";
import { useSend } from "./hooks/useSend";
import { useVerify } from "./hooks/useVerify";

export function AlternativeOtp({ onClose }) {
  const { tAuth: t } = useAppTranslation.Auth({
    keyPrefix: "twoFactor.alternativeOtp",
  });

  const [answer, setAnswer] = useState("");
  const [altType, setAltType] = useState("");
  const [otp, setOtp] = useState("");

  const send = useSend();
  const verify = useVerify();

  return (
    <Modal
      isOpen
      footerNoBorder
      size="small"
      onClose={onClose}
      shouldCloseOnOverlayClick={false}
      contentClassName={styles.root}
      header={<Modal.Title>{t("title")}</Modal.Title>}
      footer={
        <Footer
          onCancel={onClose}
          sendOtp={passOr(!send.isSuccess, null, () => ({
            initiate: () => send.initiate(altType, answer),
            isLoading: send.isLoading,
            isDisabled: !answer?.trim() || !altType,
          }))}
          verifyOtp={passOr(send.isSuccess, null, () => ({
            initiate: () => verify.initiate(otp, altType),
            isLoading: verify.isLoading,
            isDisabled: !otp?.trim(),
          }))}
        />
      }
    >
      <Options value={altType} onChange={setAltType} />
      <SecurityQuestion
        answer={answer}
        setAnswer={setAnswer}
        isDisabled={send.isSuccess}
      />
      {send.isSuccess && (
        <Otp
          value={otp}
          onChange={setOtp}
          onResend={() => send.retry(altType, answer)}
          isResending={send.isRetrying}
          sentTo={send.sentTo}
        />
      )}
    </Modal>
  );
}
